import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'premium';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withArrow?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withArrow = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#fdfbf7]';
  const variants = {
    primary: 'bg-[#d4af37] hover:bg-[#e5c158] text-[#1a3622] focus:ring-[#d4af37] shadow-[0_4px_14px_0_rgba(212,175,55,0.25)] hover:shadow-[0_6px_20px_rgba(212,175,55,0.4)] hover:-translate-y-0.5',
    secondary: 'bg-[#1a3622] hover:bg-[#2c4c3b] text-white focus:ring-[#1a3622] shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    outline: 'border-2 border-[#1a3622] hover:border-[#2c4c3b] text-[#1a3622] hover:bg-[#1a3622]/5 focus:ring-[#1a3622]',
    premium: 'bg-gradient-to-r from-[#d4af37] to-[#f1d570] hover:from-[#e5c158] hover:to-[#fce895] text-[#1a3622] focus:ring-[#d4af37] shadow-[0_4px_14px_0_rgba(212,175,55,0.3)] hover:shadow-[0_6px_20px_rgba(212,175,55,0.5)] hover:-translate-y-0.5 border border-[#d4af37]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-296">
      {children}
      {withArrow && <ArrowRight className="ml-2 w-5 h-5" data-id="element-297" />}
    </motion.button>;
}